import { render, staticRenderFns } from "./BridgeView.vue?vue&type=template&id=bb395768&scoped=true"
import script from "./BridgeView.vue?vue&type=script&lang=ts"
export * from "./BridgeView.vue?vue&type=script&lang=ts"
import style0 from "./BridgeView.vue?vue&type=style&index=0&id=bb395768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb395768",
  null
  
)

export default component.exports